<form [formGroup]="note1Form">
  <div class="notes-wrapper">
    <ng-container *ngFor="let note of notes; let i = index">
      <div class="notes-section">
        <p class="fw-bold notes-heading">
          <mat-checkbox
            formControlName="checkbox{{ i + 1 }}"
            disableRipple
          ></mat-checkbox>
          {{ note.title }}
        </p>
        <ejs-richtexteditor
          [toolbarSettings]="
            commonService.syncfusionRichTextEditorToolbarSettings
          "
          (actionBegin)="
            commonService.syncfusionRichTextEditorOnActionBegin($event)
          "
          [enableXhtml]="true"
          [toolbarSettings]="commonService.syncfusionRichTextEditorTools"
          formControlName="textbox{{ i + 1 }}"
          [enableHtmlSanitizer]="true"
          [pasteCleanupSettings]="
            commonService.syncfusionRichTextEditorPasteCleanupSettings
          "
        ></ejs-richtexteditor>
      </div>
    </ng-container>
  </div>
</form>
